import {
  CREATE_CONTENT_REQUEST, CREATING_CONTENT_SUCCEEDED, CREATING_CONTENT_FAILED, UPDATE_ASSETS_CONTENT,
  ADD_ASSET_URL, ADD_ASSET_URL_SUCCEDDED, ADD_ASSET_URL_FAILED,
  UPLOAD_CONTENT_REQUEST, UPLOADING_CONTENT_PROGRESS, UPLOAD_ASSET_REQUEST,

  WS_ASSET_PROCESSED,

  CREATE_ASSET_MAPPING_REQUEST, CREATING_ASSET_MAPPING_SUCCEEDED, CREATING_ASSET_MAPPING_FAILED,
  FETCH_ASSET_MAPPINGS_REQUEST, FETCHING_ASSET_MAPPINGS_SUCCEEDED, FETCHING_ASSET_MAPPINGS_FAILED,
  CREATING_GATING_CONFIGURATION_FOR_MAPPING_SUCCEEDED,
  DELETE_ASSET_MAPPINGS_REQUEST, DELETING_ASSET_MAPPINGS_SUCCEEDED, DELETING_ASSET_MAPPINGS_FAILED,
  DELETE_ASSET_REQUEST,

  FETCH_PREVIEW_FOR_ASSET_REQUEST, FETCHING_PREVIEW_FOR_ASSET_SUCCEEDED, FETCHING_PREVIEW_FOR_ASSET_FAILED,
  FETCHING_PREVIEW_TEXT_FOR_ASSET_SUCCEEDED,
  UPDATE_ASSET_MAPPING_REQUEST, UPDATING_ASSET_MAPPING_SUCCEEDED, INVALIDATE_ASSET_MAPPINGS,
  DELETE_GATING_CONFIGURATION_REQUEST, DELETING_ASSET_MAPPINGS_GATING_SUCCEEDED, DELETING_ASSET_MAPPINGS_GATING_FAILED,

  FETCH_DUPLICATE_ASSETS_REQUEST, FETCHING_DUPLICATE_ASSETS_SUCCEEDED, FETCHING_DUPLICATE_ASSETS_FAILED, INVALIDATE_DUPLICATE_ASSETS,
  UPDATE_ASSET_MAPPINGS_REQUEST, UPDATING_ASSET_MAPPINGS_SUCCEEDED, UPDATING_ASSET_MAPPINGS_FAILED, CREATE_GATING_CONFIGURATION_REQUEST,
  UPDATE_GATING_CONFIGURATION_REQUEST, FETCH_ALIASES_FOR_ASSET_REQUEST, FETCHING_ALIASES_FOR_ASSET_SUCCEDDED, FETCHING_ALIASES_FOR_ASSET_FAILED, 
  UPDATE_ALIASES_FOR_ASSET, UPDATING_ALIASES_FOR_ASSET_SUCCEEDED, UPDATING_ALIASES_FOR_ASSET_FAILED,
  CREATE_ALIASES_FOR_ASSET, CREATING_ALIASES_FOR_ASSET_SUCCEEDED, CREATING_ALIASES_FOR_ASSET_FAILED, INVALIDATE_CREATE_ALIASES_FOR_ASSET, 
  DELETE_ALIASES_FOR_ASSET, DELETING_ALIASES_FOR_ASSET_SUCCEEDED, DELETING_ALIASES_FOR_ASSET_FAILED, INVALIDATE_ALIASES_FOR_ASSET,
  CREATE_ASSET_VERSION_REQUEST, CREATING_ASSET_VERSION_SUCCEEDED, CREATING_ASSET_VERSION_FAILED,UPLOADING_ASSET_VERSION_PROGRESS, UPLOADING_ASSET_VERSION_STARTED,

  FETCH_ASSET_MAPPINGS_ON_SEARCH_REQUEST, FETCHING_ASSET_MAPPINGS_ON_SEARCH_SUCCEEDED, FETCHING_ASSET_MAPPINGS_ON_SEARCH_FAILED, 
  INVALIDATE_SEARCH_ASSET_MAPPINGS, UPDATE_FILTERS_AND_SORT_IN_CONTENT_MANAGER, INVALIDATE_FILTERS_AND_SORT_IN_CONTENT_MANAGER,

  REMOVE_ASSET_REQUEST, INVALIDATE_ASSET_SELECTION,
  ASSET_SEEK_INDEXING_REQUEST, ASSET_SEEK_INDEXING_SUCCEEDED, ASSET_SEEK_INDEXING_FAILED, FETCHING_ASSET_MAPPING_FAILED, FETCHING_ASSET_MAPPING_SUCCEEDED, FETCH_ASSET_MAPPING_REQUEST,
  INVALIDATE_ASSET_UPLOADED
} from 'constants/actionTypes.jsx';

import _ from 'lodash';

const initialState = {
  assets: [],
  assetFilters: {
    items: []
  },
  uploads: [],
  duplicates: [],
  uploading: false,
  updated: false,
  loading: true,
  updating: false,
  previews: {},
  pagination: {
    currentPage: 0,
    totalPages: 0,
    totalRecordsCount: 0,
  },
  mapping: {
    loading: false,
  },
  aliases: {
    id: null,
    loading: false,
    items: [],
    create: {
      creating: false,
      created: null,
      error: null,
    },
    update: {
      id: null,
      updating: false,
      updated: false,
      error: null,
    },
    delete: {
      id: null,
      deleting: false,
      error: null,
    }
  }
};

const initialPreviewState = {
  loading: false,
  item: null
}

export function contentReducer(state = initialState, action) {
  switch (action.type) {

    case UPLOAD_CONTENT_REQUEST: {
      const request = action.payload.file;

      return {
        ...state,
        uploads: [
          {
            id: request.id,
            entityType: "file",
            source: 'CLEVERSTORY',
            uploading: true,
            file: request
          },
          ...state.uploads
        ],
        uploading: true
      }
    }

    case UPLOADING_CONTENT_PROGRESS: {
      const { file, progress } = action.payload;

      let uploads = state.uploads.map(item => {
        if (_.get(item, 'file.id', null) === file.id) {
          return {
            ...item,
            progress: progress
          }
        }

        return item;
      });

      return {
        ...state,
        uploads: uploads
      }

    }

    case UPLOADING_ASSET_VERSION_STARTED: {
      const { id, file } = action.payload;

      let assets = [...state.assets];

      assets = assets.map(item => {
        if (item.asset.id === id) {
          return {
            ...item,
            updating: true
          }
        }
        return item;
      })

      return {
        ...state,
        assets: assets,
      }
    }

    case UPLOADING_ASSET_VERSION_PROGRESS: {
      const { file, progress, id } = action.payload;

      let assets = [...state.assets];
      assets = assets.map(item => {
        if (item.asset.id === id) {
          return {
            ...item,
            progress: progress,
          }
        }
        return item;
      })

      return {
        ...state,
        assets: assets
      }

    }

    case CREATE_ASSET_VERSION_REQUEST: {
      const { id, isUrlAsset } = action.payload;

      let assets = [...state.assets];

      if(isUrlAsset){
        assets = assets.map(item => {
          if (item.asset.id === id) {
            return {
              ...item,
              updating: true
            }
          }
          return item;
        })
      }

      return {
        ...state,
        assets: assets
      }
    }

    case CREATING_ASSET_VERSION_SUCCEEDED: {
      const { id, response } = action.payload;

      let assets = [...state.assets];

      assets = assets.map(item => {
        if (item.asset.id === id) {
          return {
            ...item,
            asset: {...response},
            updating: false,
            progress: null
          }
        }
        return item;
      })

      return {
        ...state,
        assets: assets,
      }
    }

    case CREATING_ASSET_VERSION_FAILED: {
      const { id, error } = action.payload;

      let assets = [...state.assets];

      assets = assets.map(item => {
        if (item.asset.id === id) {
          return {
            ...item,
            updating: false,
            progress: null,
            error: error
          }
        }
        return item;
      })

      return {
        ...state,
        assets: assets,
      }
    }


    case CREATE_CONTENT_REQUEST: {
      const { file } = action.payload;

      let uploads = state.uploads.map(item => {
        if (_.get(item, 'file.id', null) === file.id) {
          return {
            ...item,
            uploading: false,
            creating: true
          }
        }

        return item;
      });

      return {
        ...state,
        uploads: uploads
      }
    }

    case CREATING_CONTENT_SUCCEEDED: {
      const { file, asset } = action.payload;

      let uploads = state.uploads.map(item => {
        if (_.get(item, 'file.id', null) === file.id) {
          return {
            ...item,
            asset: asset,
            creating: false
          }
        }

        return item;
      });

      return {
        ...state,
        uploads: uploads,
        uploading: false
      }
    }

    case CREATING_CONTENT_FAILED: {
      const { file, error } = action.payload;

      let uploads = state.uploads.map(item => {
        if (_.get(item, 'file.id', null) === file.id) {
          return {
            ...item,
            creating: false,
            error: error
          };
        } else {
          return item;
        }
      });

      return {
        ...state,
        uploads: uploads,
        uploading: false
      }
    }

    case UPLOAD_ASSET_REQUEST: {
      const { asset } = action.payload;

      return {
        ...state,
        uploads: [
          ...state.uploads,
          asset
        ]
      }
    }

    case REMOVE_ASSET_REQUEST: {
      const { asset } = action.payload;

      let index = state.uploads.findIndex(item => item.asset.id === asset);
      state.uploads.splice(index, 1);

      return {
        ...state,
        uploads: [
          ...state.uploads
        ]
      }
    }

    case UPDATE_ASSETS_CONTENT: {
      const { id, request } = action.payload;

      let assets = [...state.assets];

      assets = assets.map(item => {
        if (item.id === id) {
          return {
            ...request,
            changes: true,
          }
        }
        return item;
      })

      return {
        ...state,
        assets: assets
      }
    }


    case ASSET_SEEK_INDEXING_REQUEST: {
      const { request } = action.payload;

      let assets = [...state.assets];

      assets = assets.map(item => {
        if (item.id === request.content) {
          return {
            ...request,
            seekProcessing: true,
          }
        }
        return item;
      })

      return {
        ...state,
        assets: assets
      }
    }

    case ASSET_SEEK_INDEXING_SUCCEEDED: {
      const { request, response } = action.payload;

      let assets = [...state.assets];

      assets = assets.map(item => {
        if (item.id === response.id) {
          return response;
        }
        return item;
      })

      return {
        ...state,
        assets: assets
      }
    }

    case ASSET_SEEK_INDEXING_FAILED: {
      const { request, error } = action.payload;

      let assets = [...state.assets];

      assets = assets.map(item => {
        if (item.id === request.content) {
          return {
            ...request,
            seekProcessing: false,
            seekError: error
          }
        }
        return item;
      })

      return {
        ...state,
        assets: assets
      }
    }


    case ADD_ASSET_URL: {
      var url = {
        entityType: "url",
        url: action.payload.url
      };

      return {
        ...state,
        uploads: [
          url,
          ...state.uploads
        ],
        uploading: true,
        uploaded: false
      }
    }

    case FETCH_DUPLICATE_ASSETS_REQUEST: {
      const { id, assetMapping } = action.payload;

      return{
        ...state,
        duplicates:[
          ...state.duplicates,
          {
            id: id,
            assetMapping: assetMapping,
            processed: false,
            duplicateAsset: null,
            similarAsset: null
          }
        ]
      }

    }

    case FETCHING_DUPLICATE_ASSETS_SUCCEEDED: {
      const { id, response } = action.payload;

      let duplicates = [...state.duplicates];
    
      const updatedDuplicates = duplicates.map(item => {
          if (item.id === id) {
            return {
              ...item,
              processed: true,
              duplicateAsset: response.asset,
              similarAsset: response.similarAssets[0]
            };
          }
          return item;
        });

      return{
        ...state,
        duplicates: updatedDuplicates
      }
    }
    
    case FETCHING_DUPLICATE_ASSETS_FAILED: {
      const { id, error } = action.payload;

      let duplicates = [...state.duplicates];

      const updatedDuplicates = duplicates.map(item => {
        if (item.id === id) {
          return {
            ...item,
            processed: true,
            error: error
          };
        }
        return item;
      });

      return{
        ...state,
        duplicates: updatedDuplicates
      }
    }

    case INVALIDATE_DUPLICATE_ASSETS: {
      return{
        ...state,
        duplicates: []
      }
    }

    case ADD_ASSET_URL_SUCCEDDED: {
      var uploads = state.uploads.map(item => {
        if (item.entityType === "url" && item.url === action.payload.url) {
          return  {
            ...action.payload.asset[0],
            source: 'CLEVERSTORY'
          };
        } else {
          return item;
        }
      });

      return {
        ...state,
        uploads: uploads,
        uploading: false,
        uploaded: true
      }
    }

    case ADD_ASSET_URL_FAILED: {
      var uploads = state.uploads.filter(item => {
        if (item.type === "url" && item.url === action.payload.url) {
          return false;
        }

        return true;
      });

      return {
        ...state,
        uploads: uploads,
        uploading: false,
        uploaded: false
      }
    }

    case WS_ASSET_PROCESSED: {
      let uploads = state.uploads.map(item => {
        const id = _.get(item, 'asset.id');
        if (id === action.payload.id) {
          return {
            ...item,
            asset: action.payload,
          }
        }

        return item;
      });

      let assets = state.assets.map(item => {
        const id = _.get(item, 'asset.id');
        if (action.payload.id === id) {
          return {
            ...item,
            asset: action.payload,
            updating: false,
            progress: null
          }
        }
        return item;
      })

      return {
        ...state,
        assets: assets,
        uploads: uploads,
      }
    }

    case CREATE_ASSET_MAPPING_REQUEST: {
      const { request } = action.payload;

      let asset = _.get(request, 'assetRequests[0]', null);

      if (!asset) {
        return asset;
      }

      let assets = [...state.assets];
      assets = assets.map(item => {
        const id = _.get(item, 'asset.id');
        if (id === asset) {
          return {
            ...item,
            creatingAssetMapping: true,
          }
        }

        return item;
      })

      return {
        ...state,
        assets: assets
      };
    }

    case CREATING_ASSET_MAPPING_SUCCEEDED: {
      const { response } = action.payload;

      let assetMapping = _.get(response, '[0]', null);

      if (!assetMapping) {
        return {
          ...state,
          uploads: []
        };
      }

      let assets = state.assets.map(item => {
        const id = _.get(item, 'asset.id');
        if (id === assetMapping.asset.id) {
          return {
            ...assetMapping,
            entityType: 'asset',
            creatingAssetMapping: false,
            createdAssetMapping: true
          }
        }

        return item;
      });

      return {
        ...state,
        assets: assets,
        updated: true,
        uploads: []
      };
    }

    case CREATING_ASSET_MAPPING_FAILED: {
      const { request } = action.payload;

      let asset = _.get(request, 'assetRequests[0]', null);

      if (!asset) {
        return asset;
      }

      let assets = state.assets.map(item => {
        const id = _.get(item, 'asset.id');
        if (item.entityType === 'asset' && id === asset.id) {
          return null;
        }

        return item;
      }).filter(item => item !== null);

      return {
        ...state,
        assets: assets
      };
    }

    case FETCH_ASSET_MAPPINGS_REQUEST: {
      const { request, page, limit, requestId } = action.payload;

      let assets = [...state.assets];
      if (page === 0) {
        assets = [];
      }

      return {
        ...state,
        requestId: requestId,
        query: request.query,
        loading: true,
        updated: false,
        assets: assets
      }
    }

    case CREATING_GATING_CONFIGURATION_FOR_MAPPING_SUCCEEDED: {
      const { id, response } = action.payload;
    
      if (!response || response.length === 0) {
        return state;
      }
    
      const assets = state.assets.map(asset => {
        if (asset.id !== id) {
          return asset;
        }
    
        const existingConfigs = asset.gatingConfigurations || [];
        const updatedConfigs = existingConfigs.filter(config => 
          !response.some(newConfig => newConfig.id === config.id)
        );

        return {
          ...asset,
          gatingConfigurations: [...updatedConfigs, ...response]
        };
      });
    
      return {
        ...state,
        assets
      };
    }

    case FETCHING_ASSET_MAPPINGS_SUCCEEDED: {
      const { request, response, requestId } = action.payload;
      const { records, ...pagination } = response;

      let items = [...state.assets, ...records];
      items = _.filter(items, data => data.asset.id !== null)
      items = _.uniqBy(items, 'id');

      if (state.query && state.query !== request.query) {
        return state;
      }

      if(state.requestId && state.requestId !== requestId) {
        return state;
      }

      return {
        ...state,
        loading: false,
        assets: items,
        pagination: pagination
      }
    }

    case FETCHING_ASSET_MAPPINGS_FAILED: {
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    }


    case FETCH_ASSET_MAPPING_REQUEST: {
      const { id, storyboard } = action.payload;

      return {
        ...state,
        updating: true
      }
    }

    case FETCHING_ASSET_MAPPING_SUCCEEDED: {
      const { id, response } = action.payload;
      let assets = [...state.assets];

      assets = assets.map(item => {
        if (item.id == id) {
          return {
            ...response
          }
        }
        return item;
      })

      return {
        ...state,
        updating: false,
        assets: assets,
      }
    }

    case FETCHING_ASSET_MAPPING_FAILED: {
      return {
        ...state,
        updating: false,
      }
    }

    case DELETE_ASSET_REQUEST: {

      let uploads = [...state.uploads];

      uploads = uploads.filter(item => {
        return _.get(item, 'asset.id') !== action.payload;
      })
      return {
        ...state,
        uploads: uploads
      }
    }

    case DELETE_ASSET_MAPPINGS_REQUEST: {
      let { mappings } = action.payload;
      let assets = [...state.assets];

      assets = assets.map(item => {
        let exists = mappings.some(id => id === item.asset.id);
        if (exists) {
          return {
            ...item,
            deleting: true
          }
        }
        return item;
      })

      return {
        ...state,
        assets: assets,
        deleting: true
      }
    }

    case DELETING_ASSET_MAPPINGS_SUCCEEDED: {
      const { request } = action.payload;

      let assets = [...state.assets];
      assets = assets.filter(item => {
        let exists = (request.mappings).some(id => id === item.asset.id);
        return !exists;
      })

      return {
        ...state,
        deleting: false,
        assets: assets
      }
    }

    case DELETING_ASSET_MAPPINGS_FAILED: {
      return {
        ...state,
        deleting: false,
        error: action.payload.errors
      }
    }

    case FETCH_PREVIEW_FOR_ASSET_REQUEST: {
      const { id } = action.payload;

      var preview = state.previews[id] || initialPreviewState;

      return {
        ...state,
        previews: {
          ...state.previews,
          [id]: {
            ...preview,
            loading: true
          }
        }
      }
    }

    case FETCHING_PREVIEW_FOR_ASSET_SUCCEEDED: {
      const { id, response } = action.payload;

      var preview = state.previews[id] || initialPreviewState;

      return {
        ...state,
        previews: {
          ...state.previews,
          [id]: {
            ...preview,
            loading: false,
            item: response
          }
        }
      }
    }

    case FETCHING_PREVIEW_FOR_ASSET_FAILED: {
      const { id, error } = action.payload;

      var preview = state.previews[id] || initialPreviewState;

      return {
        ...state,
        previews: {
          ...state.previews,
          [id]: {
            ...preview,
            loading: false,
            error: error
          }
        }
      }
    }

    case FETCHING_PREVIEW_TEXT_FOR_ASSET_SUCCEEDED: {
      var { id, response } = action.payload;
      var preview = state.previews[id] || initialPreviewState;

      if (!(preview.item && preview.item.pages.length > 0)) {
        return state;
      }

      var pages = preview.item.pages.map((page, index) => {
        var item = _.get(response, `pages[${index}]`);
        return {
          ...page,
          width: item.width,
          height: item.height,
          texts: item.texts
        }
      });

      return {
        ...state,
        previews: {
          ...state.previews,
          [id]: {
            ...preview,
            item: {
              ...preview.item,
              pages: pages,
              fonts: action.payload.fonts
            }
          }
        }
      }
    }

    case UPDATE_ASSET_MAPPINGS_REQUEST: {
      return {
        ...state,
        updating: true
      }
    }

    case UPDATING_ASSET_MAPPINGS_SUCCEEDED: {
      var { id, response } = action.payload;

      return {
        ...state,
        updating: false,
        updated: true,
      }
    }

    case UPDATING_ASSET_MAPPINGS_FAILED: {
      var { id, error } = action.payload;

      return {
        ...state,
        updating: false,
        updated: false,
        error: error
      }
    }

    case DELETING_ASSET_MAPPINGS_GATING_SUCCEEDED: {
      var { response } = action.payload;

      return {
        ...state,
        updating: false,
      }
    }

    case DELETING_ASSET_MAPPINGS_GATING_FAILED: {
      var { error } = action.payload;

      return {
        ...state,
        updating: false,
        error: error
      }
    }

    case UPDATE_GATING_CONFIGURATION_REQUEST: {
      const { mappingId, id, request } = action.payload;

      var updatedGatingAssets = _.map(state.assets, (content) => {
        if (content.id === mappingId) {

          return {
            ...content,
            changes: true
          }
        }
        return content;
      })

      return {
        ...state,
        assets: updatedGatingAssets
      }
    }

    case DELETE_GATING_CONFIGURATION_REQUEST: {
      const { mappingId, id, gatingConfigId } = action.payload;
      var updatedGatingAssets = _.map(state.assets, (content) => {
        if (content.id === mappingId) {
          let filteredGatingConfiguration = _.filter(content.gatingConfigurations, data => data.id !== gatingConfigId);
          return {
            ...content,
            changes: true,
            gatingConfigurations: filteredGatingConfiguration
          }
        }
        return content;
      })

      return {
        ...state,
        assets: updatedGatingAssets
      }
    }

    case UPDATE_ASSET_MAPPING_REQUEST: {
      return {
        ...state,
        mapping: {
          loading: true
        }
      }
    }

    case UPDATING_ASSET_MAPPING_SUCCEEDED: {
      return {
        ...state,
        mapping: {
          loading: false
        }
      }
    }

    case INVALIDATE_ASSET_MAPPINGS: {
      return initialState;
    }

    case INVALIDATE_ASSET_UPLOADED: {
      return{
        ...state,
        uploaded: false
      }
    }

    case FETCH_ALIASES_FOR_ASSET_REQUEST: {
      const { filterRequest, page } = action.payload;
      const id = filterRequest.target;

      const currentAsset = _.get(state, 'aliases.id');
      let items = _.get(state, 'aliases.items');
      if (currentAsset !== id || page === 0) {
        items = [];
      }

      return {
        ...state,
        aliases: {
          ...state.aliases,
          id: id,
          loading: true,
          items,
        }
      };
    }

    case FETCHING_ALIASES_FOR_ASSET_SUCCEDDED: {
      const { filterRequest, response } = action.payload;

      const id = filterRequest.target;
      const { records, ...pagination } = response;

      const currentAsset = _.get(state, 'aliases.id');
      if (currentAsset !== id) {
        return state;
      }

      let items = _.get(state, 'aliases.items') || [];
      const page = pagination.current;

      if (page === 0) {
        items = [];
      }

      items = [...items, ...records];
      items = _.uniqBy(items, 'id');

      return {
        ...state,
        aliases: {
          ...state.aliases,
          loading: false,
          items,
          pagination,
          error: null,
        }
      };
    }

    case FETCHING_ALIASES_FOR_ASSET_FAILED: {
      const { filterRequest, error } = action.payload;
      const id = filterRequest.target;

      const currentAsset = _.get(state, 'aliases.id');
      if (currentAsset !== id) {
        return state;
      }

      return {
        ...state,
        aliases: {
          ...state.aliases,
          loading: false,
          error: error,
        }
      };
    }

    case CREATE_ALIASES_FOR_ASSET: {
      return {
        ...state,
        aliases: {
          ...state.aliases,
          create: {
            creating: true,
            created: null,
            error: null,
          }
        }
      };
    }

    case CREATING_ALIASES_FOR_ASSET_SUCCEEDED: {
      const { response } = action.payload;
      let items = _.get(state, 'aliases.items') || [];
      items = [response, ...items];
      items = _.uniqBy(items, 'id');

      items = items.map(item => {
        if (item.id !== response.id && response.canonical) {
          return {
            ...item,
            canonical: false,
          };
        }

        return item;
      });

      return {
        ...state,
        aliases: {
          ...state.aliases,
          items,
          create: {
            creating: false,
            created: response,
            error: null,
          },
          
        }
      };
    }

    case CREATING_ALIASES_FOR_ASSET_FAILED: {
      const { error } = action.payload;

      return {
        ...state,
        aliases: {
          ...state.aliases,
          create: {
            creating: false,
            created: null,
            error: error,
          }
        }
      };
    }

    case INVALIDATE_CREATE_ALIASES_FOR_ASSET: {
      let items = _.get(state, 'aliases.items') || [];
      items = items.map(item => {
        if (item.updated) {
          return {
            ...item,
            updated: false,
          };
        }

        return item;
      });

      return {
        ...state,
        aliases: {
          ...state.aliases,
          create: {
            creating: false,
            created: null,
            error: null,
          },
          update: {
            id: null,
            updating: false,
            updated: false,
            error: null,
          },
          items: items
        }
      };
    }

    case UPDATE_ALIASES_FOR_ASSET: {
      const { id } = action.payload;
      return {
        ...state,
        aliases: {
          ...state.aliases,
          update: {
            id,
            updating: true,
            updated: false,
            error: null,
          }
        }
      };
    }

    case UPDATING_ALIASES_FOR_ASSET_SUCCEEDED: {
      const { id, response, prevAlias } = action.payload;

      let currentUpdate = _.get(state, 'aliases.update');
      if (currentUpdate.id === id) {
        currentUpdate = {
          id: null,
          updating: false,
          updated: true,
          error: null,
        }
      }

      let items = _.get(state, 'aliases.items') || [];
      items = items.map(alias => {
        if (alias.id === response.id) {
          response.updated = true;
          return response;
        }

        return alias;
      }).map(item => {
        if (item.id !== response.id && response.canonical) {
          return {
            ...item,
            canonical: false,
          };
        }

        return item;
      });

      return {
        ...state,
        aliases: {
          ...state.aliases,
          items,
          update: currentUpdate,
        }
      };
    }

    case UPDATING_ALIASES_FOR_ASSET_FAILED: {
      const { id, error } = action.payload;

      let currentId = _.get(state, 'aliases.update.id');
      if (currentId !== id) {
        return state;
      }

      return {
        ...state,
        aliases: {
          ...state.aliases,
          update: {
            ...state.aliases.update,
            error,
          },
        }
      };
    }

    case DELETE_ALIASES_FOR_ASSET: {
      const { id } = action.payload;
      return {
        ...state,
        aliases: {
          ...state.aliases,
          delete: {
            id,
            deleting: true,
            error: null,
          }
        }
      };
    }

    case DELETING_ALIASES_FOR_ASSET_SUCCEEDED: {
      const { id } = action.payload;

      let currentDelete = _.get(state, 'aliases.delete');
      if (currentDelete.id === id) {
        currentDelete = {
          id: null,
          deleting: false,
          error: null,
        }
      }

      let items = _.get(state, 'aliases.items') || [];
      items = items.filter(alias => {
        return alias.id !== id;
      });

      return {
        ...state,
        aliases: {
          ...state.aliases,
          items,
          delete: currentDelete,
        }
      };
    }

    case DELETING_ALIASES_FOR_ASSET_FAILED: {
      const { id, error } = action.payload;

      let currentId = _.get(state, 'aliases.delete.id');
      if (currentId !== id) {
        return state;
      }

      return {
        ...state,
        aliases: {
          ...state.aliases,
          delete: {
            ...state.aliases.delete,
            deleting: false,
            error,
          },
        }
      };
    }

    case INVALIDATE_ALIASES_FOR_ASSET: {
      return {
        ...state,
        aliases: {
          id: null,
          loading: false,
          items: [],
          create: {
            creating: false,
            created: null,
            error: null,
          },
          update: {
            id: null,
            updating: false,
            error: null,
          },
          delete: {
            id: null,
            deleting: false,
            error: null,
          }
        }
      }
    }

    case UPDATE_FILTERS_AND_SORT_IN_CONTENT_MANAGER: {
      const { request } = action.payload;

      return {
        ...state,
        assetFilters: {
          ...state.assetFilters,
          ...request
        }
      }
    }

    case INVALIDATE_FILTERS_AND_SORT_IN_CONTENT_MANAGER: {
      return {
        ...state,
        assetFilters: {
          ...state.assetFilters,
          filters: [],
          sort: 'modified_date',
          order: 'DESC'
        }
      }
    }

    case FETCH_ASSET_MAPPINGS_ON_SEARCH_REQUEST: {
      const { page, request } = action.payload;

      let assets = [...state.assetFilters.items];
      if (page === 0) {
        assets = [];
      }

      return {
        ...state,
        assetFilters: {
          ...state.assetFilters,
          loading: true,
          items: assets,
          query: request.query,
        }
      }
    }

    case FETCHING_ASSET_MAPPINGS_ON_SEARCH_SUCCEEDED: {
      const { request, response } = action.payload;
      const { records } = response;

      let items = records;
      items = _.filter(items, data => data.asset.id !== null)
      items = _.uniqBy(items, 'id');

      if (state.assetFilters.query && state.assetFilters.query !== request.query) {
        return state;
      }

      return {
        ...state,
        assetFilters: {
          ...state.assetFilters,
          items: items,
          loading: false,
        }
      }
    }

    case FETCHING_ASSET_MAPPINGS_ON_SEARCH_FAILED: {
      return {
        ...state,
        assetFilters: {
          ...state.assetFilters,
          error: action.payload,
          loading: false,
        }
      }
    }

    case INVALIDATE_SEARCH_ASSET_MAPPINGS: {
      return {
        ...state,
        assetFilters: { 
          ...state.assetFilters,
          items: [],
          loading: false
        }
      }
    }

    case INVALIDATE_ASSET_SELECTION: {
      return {
        ...state,
        uploads: []
      };
    }

    default:
      return state;
  }
}
